// Zentrale Definition der Lager-Tage. Wird sowohl im Logistik-Schichtplan als
// auch beim Eintragen von Diensten (Dienstpläne) verwendet, damit es nur eine
// Quelle der Wahrheit für den Lager-Zeitraum gibt.
export const CAMP_TAGE = [
  { datum: '2026-07-04', label: 'Sa 04.07.' },
  { datum: '2026-07-05', label: 'So 05.07.' },
  { datum: '2026-07-06', label: 'Mo 06.07.' },
  { datum: '2026-07-07', label: 'Di 07.07.' },
  { datum: '2026-07-08', label: 'Mi 08.07.' },
  { datum: '2026-07-09', label: 'Do 09.07.' },
  { datum: '2026-07-10', label: 'Fr 10.07.' },
  { datum: '2026-07-11', label: 'Sa 11.07.' },
];

export function heutigesDatum() {
  const heute = new Date();
  const jahr = heute.getFullYear();
  const monat = String(heute.getMonth() + 1).padStart(2, '0');
  const tag = String(heute.getDate()).padStart(2, '0');
  return `${jahr}-${monat}-${tag}`;
}

// Liefert den heutigen Lager-Tag, falls heute im Lager-Zeitraum liegt,
// sonst den übergebenen Fallback (Standard: Montag der Lagerwoche).
export function aktuellerCampTag(fallback = CAMP_TAGE[5].datum) {
  const heute = heutigesDatum();
  return CAMP_TAGE.some(tag => tag.datum === heute) ? heute : fallback;
}
